// src/components/RightPanel.tsx
import React from "react";
import TodoList from "./TodoList";
import Diary from "./Diary";
import "../styles/RightPanel.css";
import { MoodType } from "../types/appTypes";

interface RightPanelProps {
  todos: any[];
  selectedDate: string;

  onAdd: (text: string) => void;
  onToggle: (id: number, currentStatus: boolean) => void;
  onDelete: (id: number) => void;
  onEdit: (id: number, nextTask: string) => void;

  onDiarySave: (
    id: number | null,
    date: string,
    mood: MoodType,
    text: string
  ) => Promise<void>;

  activeTab: "todo" | "diary";
  onChangeTab: (tab: "todo" | "diary") => void;
}

const RightPanel = ({
  todos,
  selectedDate,
  onAdd,
  onToggle,
  onDelete,
  onEdit,
  onDiarySave,
  activeTab,
  onChangeTab,
}: RightPanelProps) => {
  return (
    <div className="right-panel-container">
      {/* 탭 버튼 */}
      <div className="tab-buttons">
        <button
          className={activeTab === "todo" ? "active" : ""}
          onClick={() => onChangeTab("todo")}
        >
          TODO
        </button>

        <button
          className={activeTab === "diary" ? "active" : ""}
          onClick={() => onChangeTab("diary")}
        >
          일기
        </button>
      </div>

      {/* 콘텐츠 영역 */}
      <div className="rightpanel-content">
        {activeTab === "todo" ? (
          <TodoList
            todos={todos}
            date={selectedDate}
            onAdd={onAdd}
            onToggle={onToggle}
            onDelete={onDelete}
            onEdit={onEdit}
          />
        ) : (
          <Diary
            date={selectedDate}
            onSave={onDiarySave}
          />
        )}
      </div>
    </div>
  );
};

export default RightPanel;
